import {
    ref,
} from "vue";
import { getStructure } from "@/request/view/personal";


export const staffList = ref([]);

const setStaffList = (list) => {
    list.forEach((item) => {
        staffList.value.push({
            label: item.nickName,
            value: item.nickName,
        });
    });
};

const getStaffUserList = (list) => {
    const ite = (treeList) => {
        treeList.forEach((item) => {
            if (item.userList && item.userList.length > 0) {
                setStaffList(item.userList);
            }
            if (item.children && item.children.length > 0) {
                ite(item.children);
            }
        });
    };
    ite(list);
};

export const getStaffListData = () => {
    getStructure().then((res) => {
        staffList.value.length = 0;
        if (res.code === 200 && res.data) {
            getStaffUserList(res.data);
        }
    });
};
